/* Mist House Fashion | Everyday Essentials V4
   Independently configurable desktop/mobile carousel controls.
   Scrollbar indicator: always, during scroll, or hidden.
   The indicator stays below the entire category row, outside the scroll area.
*/
(function () {
  'use strict';
  if (window.__mhEssentialsCarouselV4Initialised) return;
  window.__mhEssentialsCarouselV4Initialised = true;

  function initialiseSection(section) {
    if (!section || section.dataset.mhEssentialsV4Ready === 'true') return;
    var track = section.querySelector('.mh-ee__grid');
    if (!track) return;
    section.dataset.mhEssentialsV4Ready = 'true';

    var controls = section.querySelector('[data-mh-ee-arrows]');
    var prev = controls ? controls.querySelector('[data-mh-ee-direction="prev"]') : null;
    var next = controls ? controls.querySelector('[data-mh-ee-direction="next"]') : null;
    var indicator = section.querySelector('[data-mh-ee-indicator]');
    var thumb = indicator ? indicator.querySelector('[data-mh-ee-thumb]') : null;
    var idleTimer = null;
    var observer = null;

    function activeMode() {
      var mobile = window.matchMedia('(max-width: 989px)').matches;
      return {
        mobile: mobile,
        enabled: section.classList.contains(mobile ? 'mh-ee--mobile-scroll' : 'mh-ee--desktop-scroll'),
        arrows: !!(controls && controls.classList.contains(mobile ? 'mh-ee__arrows--mobile' : 'mh-ee__arrows--desktop')),
        visibility: indicator ? indicator.getAttribute(mobile ? 'data-mode-mobile' : 'data-mode-desktop') : 'hidden'
      };
    }

    function update() {
      var mode = activeMode();
      var overflow = mode.enabled && track.scrollWidth > track.clientWidth + 2;
      var limit = Math.max(0, track.scrollWidth - track.clientWidth);
      var progress = limit ? Math.max(0, Math.min(1, track.scrollLeft / limit)) : 0;

      if (controls) {
        controls.hidden = !(mode.arrows && overflow);
        if (!controls.hidden && prev && next) {
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= limit - 2;
        }
      }

      if (indicator && thumb) {
        var shouldDisplay = overflow && (mode.visibility === 'always' || mode.visibility === 'scrolling');
        indicator.hidden = !shouldDisplay;
        indicator.setAttribute('data-visibility', mode.visibility || 'hidden');
        if (shouldDisplay) {
          var thumbPct = Math.min(100, Math.max(16, track.clientWidth / track.scrollWidth * 100));
          thumb.style.width = thumbPct.toFixed(3) + '%';
          thumb.style.left = (progress * (100 - thumbPct)).toFixed(3) + '%';
        } else {
          indicator.classList.remove('mh-ee__scroll-indicator--active');
        }
      }
    }

    function showDuringScroll() {
      if (!indicator || indicator.hidden || indicator.getAttribute('data-visibility') !== 'scrolling') return;
      indicator.classList.add('mh-ee__scroll-indicator--active');
      if (idleTimer) window.clearTimeout(idleTimer);
      idleTimer = window.setTimeout(function () {
        indicator.classList.remove('mh-ee__scroll-indicator--active');
      }, 1200);
    }

    function advance(direction) {
      var item = track.querySelector('.mh-ee__grid-item');
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      var step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollBy({ left: direction * step, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { advance(-1); });
    if (next) next.addEventListener('click', function () { advance(1); });
    track.addEventListener('scroll', function () { update(); showDuringScroll(); }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    if (window.ResizeObserver) {
      observer = new ResizeObserver(update);
      observer.observe(track);
    }
    update();
  }

  function initialiseAll(root) {
    if (!root) return;
    if (root.matches && root.matches('.mh-ee')) initialiseSection(root);
    var sections = root.querySelectorAll ? root.querySelectorAll('.mh-ee') : [];
    for (var i = 0; i < sections.length; i++) initialiseSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialiseAll(document); });
  } else {
    initialiseAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialiseAll(event.target); });
})();
